<template>
  <Dialog
    :visible="visible"
    :title="$t(`${namespace}.title`)"
    max-width="550"
    @close="close"
  >
    <div>

      <v-card-text class="dialog__body">
        <p v-html="$t(`${namespace}.text`)" />
      </v-card-text>

      <v-divider />

      <v-card-actions class="dialog__footer">
        <v-spacer/>

        <a class="mr-4" @click.prevent="close">
          {{ $t(`${namespace}.cancel`) }}
        </a>

        <Button @click="cancel">
          {{ $t(`${namespace}.proceed`) }}
        </Button>
      </v-card-actions>
    </div>
  </Dialog>
</template>

<script>
export default {
  name: 'CancelDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      namespace: 'Views.BulkImportPage.cancelDialog'
    }
  },
  methods: {
    cancel () {
      this.$emit('close', true)
    },

    close () {
      this.$emit('close')
    }
  }
}
</script>
